import React from 'react'
import styled, { css } from 'styled-components'

const width = '34'
const height = '34'
const viewBox = '0 0 100 100'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      key="key-0"
      d="M50,95.39A45.54,45.54,0,0,1,4.75,50,44.43,44.43,0,0,1,7.61,34.15L34.08,87.43c.35.7.77,1.26,1.6,1.26a1.76,1.76,0,0,0,1.61-1.26l12.15-27.3c.14-.28.28-.56.56-.56s.42.28.56.56l12.15,27.3a1.76,1.76,0,0,0,1.61,1.26c.83,0,1.25-.56,1.6-1.26L92.39,34.15A44.43,44.43,0,0,1,95.25,50,45.54,45.54,0,0,1,50,95.39Zm0-55.66c-.28,0-.42-.27-.56-.55L35.2,7.19a43.74,43.74,0,0,1,29.6,0l-14.24,32C50.42,39.46,50.28,39.73,50,39.73ZM35.54,72.56c-.27,0-.41-.28-.55-.56L11.94,25.56A46.75,46.75,0,0,1,28.21,10.27L44.76,47.14A1.16,1.16,0,0,0,46,48h8a1.16,1.16,0,0,0,1.26-.83L71.79,10.27A46.75,46.75,0,0,1,88.06,25.56L65,72c-.14.28-.28.56-.55.56S64,72.28,63.9,72L55.24,52.16A1.17,1.17,0,0,0,54,51.33H46a1.17,1.17,0,0,0-1.26.83L36.1,72C36,72.28,35.82,72.56,35.54,72.56ZM50,100A50,50,0,1,0,0,50,50,50,0,0,0,50,100Z"
      fill="#A4ACBA"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'BrandVw'
})
